import script from "./boot-item-detail-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./boot-item-detail-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./boot-item-detail-drawer.vue?vue&type=style&index=0&id=35bbc87a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35bbc87a"]])

export default __exports__